module.exports = __webpack_public_path__ + "static/img/图片 11.6a0430f0.png";